import Vue from 'vue'
import Router from 'vue-router'
import Datanalyze from './views/Datanalyze.vue'

import Login from './views/Login.vue'

// offer
import OfferList from './views/OfferList.vue'
import OfferEdit from './views/OfferEdit.vue'
import CampList from './views/CampList.vue'
import CampEdit from './views/CampEdit.vue'
import TopOfferList from './views/TopOfferList.vue'
import TopOfferEdit from './views/TopOfferEdit.vue'

// mmp offer
import mmpOfferList from './views/mmpOffer.vue'
import mmpOfferEdit from './views/mmpOfferEdit.vue'
import mmpCampList from './views/mmpCamp.vue'
import mmpCampEdit from './views/mmpCampEdit.vue'

// adv
import AdvList from './views/Advertiser.vue'
import AdvEdit from './views/AdvertiserEdit.vue'
import AdvRuleList from './views/AdvRuleList.vue'
import AdvRuleEdit from './views/AdvRuleEdit.vue'

//channel
import ChannelList from './views/ChannelList.vue'
import ChannelEdit from './views/ChannelEdit.vue'
import ChannelRuleList from './views/ChannelRuleList.vue'
import ChannelRuleEdit from './views/ChannelRuleEdit.vue'

//report
import Report from './views/Report.vue'

// finance
import AdvSummaryList from './views/AdvSummaryList.vue'
import AdvSummaryEdit from './views/AdvSummaryEdit.vue'
import AdvOfferList from './views/AdvOfferList.vue'
import AdvOfferEdit from './views/AdvOfferEdit.vue'
import ChannelSummaryList from './views/ChannelSummaryList.vue'
import ChannelSummaryEdit from './views/ChannelSummaryEdit.vue'
import ChannelOfferList from './views/ChannelOfferList.vue'

// mmp finace
import AdvMmpSummaryList from './views/AdvMmpSummaryList.vue';
import AdvMmpSummaryEdit from './views/AdvMmpSummaryEdit.vue';
import AdvMmpOfferList from './views/AdvMmpOfferList.vue';
import AdvMmpOfferEdit from './views/AdvMmpOfferEdit.vue';
import ChannelMmpSummaryList from './views/ChannelMmpSummaryList.vue';
import ChannelMmpSummaryEdit from './views/ChannelMmpSummaryEdit.vue';
import ChannelMmpOfferList from './views/ChannelMmpOfferList.vue';

//risk ip
import BlackIpList from './views/BlackIpList.vue'
import BlackIpCreate from './views/BlackIpCreate.vue'
import TopIP from './views/TopIP.vue'

// log
import offerStatusLog from './views/offerStatusLog'
import offerTraceLog from './views/OfferTraceLog'
import eventLog from './views/EventLog'
import converTimeLog from './views/ConverTimeLog'
import impLog from './views/ImpLog'

// tool
import Postback from './views/Postback.vue'
import CountryCode from './views/CountryCode.vue'
import SubidTransform from './views/SubidTransform.vue'
import SubidTransformOld from './views/SubidTransformOld.vue'
import UrlJump from './views/UrlJump.vue'
import DictList from './views/DictList.vue'
import AfEventLog from './views/AfEventLog.vue'
import setOtpauthMigrationToDict from './views/setOtpauthMigrationToDict.vue'
import AfCode from './views/AfCode.vue'

// user
import UserList from './views/UserList.vue'
import UserEdit from './views/UserEdit.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect:'/report'
		},
		{
			path: '/datanalyze',
			name: 'datanalyze',
			component: Datanalyze
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		//offer
		{
			path: '/offerList',
			name: 'offerList',
			component: OfferList
		},
		{
			path: '/offerEdit',
			name: 'offerEdit',
			component: OfferEdit,
			props:{edit:true}
		},{
			path: '/offercreate',
			name: 'offerCreate',
			component: OfferEdit
		},
		{
			path: '/campList',
			name: 'campList',
			component: CampList
		},
		{
			path: '/campEdit',
			name: 'campEdit',
			component: CampEdit,
			props:{edit:true}
		},
		{
			path: '/topOffer',
			name: 'topOffer',
			component: TopOfferList
		},
		{
			path: '/topOfferEdit',
			name: 'topOfferEdit',
			component: TopOfferEdit,
			props:{edit:true}
		},
		// mmp offer
		{
			path: '/mmpOfferList',
			name: 'mmpOfferList',
			component: mmpOfferList
		},
		{
			path: '/mmpOfferEdit',
			name: 'mmpOfferEdit',
			component: mmpOfferEdit,
			props:{edit:true}
		},
		{
			path: '/mmpOffercreate',
			name: 'mmpOfferCreate',
			component: mmpOfferEdit
		},
		{
			path: '/mmpCampList',
			name: 'mmpCampList',
			component: mmpCampList
		},
		{
			path: '/mmpCampEdit',
			name: 'mmpCampEdit',
			component: mmpCampEdit,
			props:{edit:true}
		},
		//adv
		{
			path: '/advList',
			name: 'advList',
			component: AdvList
		},
		{
			path: '/advEdit',
			name: 'advEdit',
			component: AdvEdit,
			props: { edit:true },

		},
		{
			path: '/advCreate',
			name: 'advCreate',
			component: AdvEdit,
		},
		{
			path: '/advRuleList',
			name: 'advRuleList',
			component: AdvRuleList,
		},
		{
			path: '/advRuleEdit',
			name: 'advRuleEdit',
			component: AdvRuleEdit,
			props: { edit:true },
		},

		//channel
		{
			path: '/channelList',
			name: 'channelList',
			component: ChannelList,
		},
		{
			path: '/channelEdit',
			name: 'channelEdit',
			component: ChannelEdit,
			props: { edit:true },

		},
		{
			path: '/channelCreate',
			name: 'channelCreate',
			component: ChannelEdit,
		},
		{
			path: '/channelRuleList',
			name: 'channelRuleList',
			component: ChannelRuleList,
		},
		{
			path: '/channelRuleEdit',
			name: 'channelRuleEdit',
			component: ChannelRuleEdit,
			props: { edit:true },
		},

		//report
		{
			path: '/report',
			name: 'report',
			component: Report,
		},

		// finance
		{
			path: '/AdvSummaryEdit',
			name: 'advSummaryEdit',
			component: AdvSummaryEdit,
		},
		{
			path: '/advSummaryList',
			name: 'advSummaryList',
			component: AdvSummaryList,
		},
		{
			path: '/advOfferList',
			name: 'advOfferList',
			component: AdvOfferList,
		},
		{
			path: '/advOfferEdit',
			name: 'advOfferEdit',
			component: AdvOfferEdit,
		},
		{
			path: '/channelSummaryList',
			name: 'channelSummaryList',
			component: ChannelSummaryList,
		},
		{
			path: '/channelSummaryEdit',
			name: 'channelSummaryEdit',
			component: ChannelSummaryEdit,
		},
		{
			path: '/channelOfferList',
			name: 'channelOfferList',
			component: ChannelOfferList,
		},

		// mmp finance
		{
			path: '/AdvMmpSummaryEdit',
			name: 'advMmpSummaryEdit',
			component: AdvMmpSummaryEdit,
		},
		{
			path: '/advMmpSummaryList',
			name: 'advMmpSummaryList',
			component: AdvMmpSummaryList,
		},
		{
			path: '/advMmpOfferList',
			name: 'advMmpOfferList',
			component: AdvMmpOfferList,
		},
		{
			path: '/advMmpOfferEdit',
			name: 'advMmpOfferEdit',
			component: AdvMmpOfferEdit,
		},
		{
			path: '/channelMmpSummaryList',
			name: 'channelMmpSummaryList',
			component: ChannelMmpSummaryList,
		},
		{
			path: '/channelMmpSummaryEdit',
			name: 'channelMmpSummaryEdit',
			component: ChannelMmpSummaryEdit,
		},
		{
			path: '/channelMmpOfferList',
			name: 'channelMmpOfferList',
			component: ChannelMmpOfferList,
		},

		// risk ip
		{
			path: '/blackIpList',
			name: 'blackIpList',
			component: BlackIpList,
		},
		{
			path: '/blackIpCreate',
			name: 'blackIpCreate',
			component: BlackIpCreate,
		},
		{
			path: '/topIP',
			name: 'topIP',
			component: TopIP,
		},

		// log
		{
			path: '/offerStatusLog',
			name: 'offerStatusLog',
			component: offerStatusLog,
		},
		{
			path: '/offerTraceLog',
			name: 'offerTraceLog',
			component: offerTraceLog,
		},
		{
			path: '/eventLog',
			name: 'eventLog',
			component: eventLog,
		},
		{
			path: '/converTimeLog',
			name: 'converTimeLog',
			component: converTimeLog,
		},
		{
			path: '/impLog',
			name: 'impLog',
			component: impLog,
		},

		// tools
		{
			path: '/postback',
			name: 'postback',
			component:	Postback,
		},
		{
			path: '/countrycode',
			name: 'countrycode',
			component: CountryCode,
		},
		{
			path: '/subidTransform',
			name: 'subidTransform',
			component: SubidTransform,
		},
		{
			path: '/subidTransformOld',
			name: 'subidTransformOld',
			component: SubidTransformOld,
		},
		{
			path: '/urlJump',
			name: 'urlJump',
			component: UrlJump,
		},
		{
			path: '/dictList',
			name: 'dictList',
			component: DictList,
		},
		{
			path: '/afEventLog',
			name: 'afEventLog',
			component: AfEventLog,
		},
		{
			path: '/setOtpauthMigrationToDict',
			name: 'setOtpauthMigrationToDict',
			component: setOtpauthMigrationToDict,
		},
		{
			path: '/afCode',
			name: 'afCode',
			component: AfCode,
		},

		// user
		{
			path: '/user',
			name: 'user',
			component: UserList,
		},
		{
			path: '/userCreate',
			name: 'userCreate',
			component: UserEdit,
		},
		{
			path: '/userEdit',
			name: 'userEdit',
			component: UserEdit,
			props: { edit:true },
		},
	]
})
